// import { fileUrl } from "../apiUtils/apiPath";
import Logger from "./logger";
import { toast } from 'react-toastify';

const handleDialpadNavigation = () => {
  window.location.href = `tel:${6366937422}`;
};

const handleWhatsAppNavigation = () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  // Create the WhatsApp URL based on the user's device
  const whatsappURL = isMobile
    ? `https://wa.me/${'9585653131'}`
    : `https://web.whatsapp.com/send?phone=${'9585653131'}`;

  // Redirect the user to the generated WhatsApp URL
  window.location.href = whatsappURL;
};

const handleGmailNavigation = () => {
  const toEmail = 'bookmyscan@gmail.com';
  const subject = 'Your subject here';
  const body = 'Your email body here';

  // Construct the mailto link
  const mailtoLink = `mailto:${toEmail}`;

  // Open the link in a new tab or window
  window.open(mailtoLink, '_blank');
};

const validateEmail = (input) => {
  // Regular expression for a simple email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(input);
};

const validateIndianMobile = (input) => {
  const IsindianMob = /^[6-9]\d{9}$/gi
  Logger("Indian Mobile>>>>>>>>>", IsindianMob.test(input))
  return IsindianMob.test(input)
}

const formatNumbersWithCommas = (number) => {
  const parts = number.toString().split('.');
  parts[0] = parts[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  // replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return parts.join('.');
}

const notifyError = (msg) => toast.error(
  msg,
  {
    pauseOnHover: false,
    autoClose: 4000,
    position: 'bottom-center'
  }
);

const notifySuccess = (msg) => toast.success(
  msg,
  {
    pauseOnHover: false,
    autoClose: 4000,
    position: 'bottom-center'
  }
);

// const handleOpenFileTab = (imageUrl) => {
//   Logger("Image URL >>>>>>>>>", imageUrl)
//   // Open the image URL in a new tab
//   window.open(`${fileUrl}${imageUrl}`, '_blank');
// };

const checkNull = (value) => {
  return value !== null && value !== '' && value !== undefined
}

export { handleDialpadNavigation, handleWhatsAppNavigation, handleGmailNavigation, validateEmail, formatNumbersWithCommas, validateIndianMobile, notifyError, notifySuccess, checkNull }